import { WarehouseGridSchema } from "@redotech/redo-model/wms/schema/warehouse-grid";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const RouteStopSchema_ = z.object({
  coordinate: z.object({ x: z.number(), y: z.number() }),
  binName: z.string(),
  products: z.array(
    z.object({
      productId: z.string(),
      productTitle: z.string(),
      sku: z.string().nullish(),
      imageUrl: z.string().nullish(),
      quantity: z.number(),
      quantityPicked: z.number(),
      fulfillmentGroupId: z.string().nullish(),
    }),
  ),
});
export const RouteStopSchema: z.ZodType<RouteStop> = RouteStopSchema_;
export interface RouteStop extends z.infer<typeof RouteStopSchema_> {}

export const getPickSessionRoute = {
  name: "getPickSessionRoute" as const,
  input: z.object({ pickSessionId: zExt.objectId() }),
  output: z
    .object({
      warehouseGrid: WarehouseGridSchema,
      route: z.array(RouteStopSchema),
      /** Items that couldn't be mapped to the warehouse */
      unmappedItems: z.array(
        z.object({
          bin: z.string().nullish(),
          productTitle: z.string(),
          sku: z.string().nullish(),
          quantity: z.number(),
        }),
      ),
      /** Total distance of the route in grid cells */
      totalDistance: z.number(),
    })
    .nullable(),
};
